(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oumnh-age-gate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oumnh-age-gate')) {
    customElements.define(
      'oumnh-age-gate',
      class OumnhAgeGate extends HTMLElement {
        connectedCallback() {
          // Not shown inside the Theme Editor so the page can still be edited.
          if (window.Shopify && window.Shopify.designMode) return;

          let verified = false;
          try {
            verified = sessionStorage.getItem('oumnhAgeVerified') === 'true';
          } catch (error) {
            verified = false;
          }
          if (verified) return;

          const template = this.querySelector('template');
          if (!template) return;

          this.overlay = template.content.firstElementChild.cloneNode(true);
          document.body.appendChild(this.overlay);
          document.body.style.overflow = 'hidden';

          this.overlay.querySelector('[data-oumnh-age-gate="yes"]').addEventListener('click', () => {
            try {
              sessionStorage.setItem('oumnhAgeVerified', 'true');
            } catch (error) {
              // Storage blocked: allow access for this page view only.
            }
            this.close();
          });

          this.overlay.querySelector('[data-oumnh-age-gate="no"]').addEventListener('click', () => {
            window.location.href = this.dataset.redirect || '/';
          });

          this.overlay.querySelector('[data-oumnh-age-gate="yes"]').focus();
        }

        disconnectedCallback() {
          this.close();
        }

        close() {
          if (!this.overlay) return;
          this.overlay.remove();
          this.overlay = null;
          document.body.style.overflow = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oumnh-announcement-split"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oumnh-announcement-split')) {
    customElements.define(
      'oumnh-announcement-split',
      class OumnhAnnouncementSplit extends HTMLElement {
        connectedCallback() {
          this.messages = Array.from(this.querySelectorAll('.oumnh-announcement-split__middle > *'));
          if (this.messages.length < 2) return;

          this.classList.add('is-rotating');
          this.index = 0;
          this.show(0);
          this.timer = setInterval(() => this.show((this.index + 1) % this.messages.length), Number(this.dataset.speed) || 5000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        show(index) {
          this.messages.forEach((message, i) => {
            message.hidden = i !== index;
          });
          this.index = index;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
